<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['invoices.menu'])">
  <div class="d-flex justify-content-between align-items-center">
    <h5 class="title-secondary">
      {{ 'INVOICES.CLIENT_INVOICES_LIST.TITLE' | translate }}
    </h5>

    <div>
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="invoicesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    [rowClass]="invoiceRowCallback"
    #grid
    (excelExport)="onExcelExport($event, 'Client_invoices', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="120"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="company.abbreviation"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.company.shortName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [filterable]="false"
      [sortable]="false"
      field="clientable.name"
      [hidden]="isHiddenColumn('clientable.name')"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.CLIENTABLE_NAME' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-client-box [client]="dataItem.clientable" [flag]="true"></app-client-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [filterable]="false"
      [sortable]="false"
      field="invoiceable.sale.event.name"
      [hidden]="isHiddenColumn('invoiceable.sale.event.name')"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.EVENT' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.invoiceable?.sale?.event?.name }}
        {{ dataItem.invoiceable?.sale?.event?.date_from | amDateFormat : 'YYYY' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [filterable]="false"
      [sortable]="false"
      field="hotels"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.HOTELS' | translate }}"
      [hidden]="isHiddenColumn('hotels')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let hotel of dataItem?.hotels; let i = index">
          {{ hotel }}<span *ngIf="i !== dataItem?.hotels?.length - 1">, </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.TYPE' | translate }}"
      [hidden]="isHiddenColumn('type.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'invoice'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="number"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.INVOICE_NUMBER' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('number')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.formatted_number }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('date')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="due_date"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.DUE_DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('due_date')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.due_date | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="110"
      field="deposit_percent"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.DEPOSIT_PERCENT' | translate }}"
      [hidden]="isHiddenColumn('deposit_percent')"
      filter="numeric"
    ></kendo-grid-column>

    <kendo-grid-column
      field="payment_method.value"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.PAYMENT_METHOD' | translate }}"
      [hidden]="isHiddenColumn('payment_method.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'payment_method'" [filter]="filter" [field]="'payment_method_id'">
        </app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.payment_method"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="total_amount"
      filter="numeric"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.TOTAL_AMOUNT' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.total_amount | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="balance"
      filter="numeric"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.BALANCE' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span
          class="fw-bold"
          [ngClass]="{ 'theme-color-danger': dataItem.balance < 0, 'theme-color-success': dataItem.balance >= 0 }"
        >
          {{ dataItem.balance | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [filterable]="false"
      field="invoiceable_id"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.INVOICEABLE_ID' | translate }}"
      [hidden]="isHiddenColumn('invoiceable_id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="paid"
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.PAID' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('paid')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.paid"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'INVOICES.CLIENT_INVOICES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button (click)="edit(dataItem)"></app-edit-button>

        <app-download-invoice-button [invoice]="dataItem"></app-download-invoice-button>

        <app-payment-button
          [paymentable_id]="dataItem.id"
          [paymentable_type]="LaravelModelsEnum.INVOICE"
          (close)="loadData(state)"
          *ngIf="dataItem.type_id != InvoiceType.PROFORMA"
        >
        </app-payment-button>

        <a
          [ngbTooltip]="'INVOICES.CLIENT_INVOICES_LIST.VIEW_PAYMENTS' | translate"
          container="body"
          class="btn btn-warning btn-ico"
          [routerLink]="['/payments']"
          [queryParams]="{ paymentable_id: dataItem.id }"
        >
          <i class="fal fa-file-invoice-dollar"></i>
        </a>

        <!--   Task #267: #267: Finance - Invoices-->
        <button
          *ngIf="dataItem.type_id == InvoiceType.PROFORMA"
          class="btn btn-danger btn-ico"
          type="button"
          [ngbTooltip]="'INVOICES.CLIENT_INVOICES_LIST.CREATE_CANCELLATION' | translate"
          container="body"
          [swal]="{ titleText: 'INVOICES.CLIENT_INVOICES_LIST.CREATE_CANCELLATION_TITLE' | translate }"
          (confirm)="delete(dataItem)"
        >
          <i class="fal fa-ban"></i>
        </button>

        <app-sale-button
          *ngIf="dataItem?.invoiceable_type && LaravelModelsEnum.SALE_FINAL && dataItem?.invoiceable?.sale_id"
          [link]="['/sales/view']"
          [params]="{ id: dataItem.invoiceable.sale_id }"
        >
        </app-sale-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
